import { RunReportContext } from '../types';

/**
 * A stand-in RunReportContext for developing a report without a database:
 * what the compiler smoke-tests a definition against, what the studio
 * previews with until the author loads a real run, what the CLI hands a report
 * under test. One small run with a measured value, a photo and a decimated
 * capture. Obviously fake; the file ids resolve to nothing.
 */
export function sampleRunReportContext(overrides: Partial<RunReportContext> = {}): RunReportContext {
  return {
    run: {
      id: '00000000-0000-0000-0000-0000000000f1',
      title: 'Inrush current — nominal',
      status: 'PASSED',
      state: 'COMPLETED',
      completedAt: '2026-01-14T16:30:00.000Z',
      signedBy: 'tech@example.com',
      sourceTitle: 'Inrush current template',
      projectId: '00000000-0000-0000-0000-0000000000a1',
      dut: { title: 'Sample lamp', description: null, partNumber: null, serial: null },
      equipment: [{ name: 'Oscilloscope', identifier: 'oscilloscope', description: '', category: 'none', configuration: { manufacturer: 'Example', model: 'X-100' } }],
      steps: [
        {
          id: '00000000-0000-0000-0000-0000000005e1',
          title: 'Measure the maximum inrush current',
          path: ['Data Analysis'],
          status: 'PASSED',
          iteration: null,
          iterationOf: null,
          readings: [
            { parameterId: '00000000-0000-0000-0000-0000000000b1', identifier: 'maximum_current', title: 'Maximum current (A)', kind: 'output', values: [12.5], records: [], files: [], attachments: [] },
            {
              parameterId: '00000000-0000-0000-0000-0000000000b2',
              identifier: 'capture',
              title: 'Capture',
              kind: 'field',
              values: ['capture.png', 'current.csv'],
              records: [],
              files: ['capture.png', 'current.csv'],
              attachments: [
                { fileId: '00000000-0000-0000-0000-0000000f11e1', fileName: 'capture.png', kind: 'image' },
                { fileId: '00000000-0000-0000-0000-0000000f11e2', fileName: 'current.csv', kind: 'data' },
              ],
            },
          ],
        },
      ],
    },
    project: { id: '00000000-0000-0000-0000-0000000000a1', title: 'Sample project' },
    traces: {
      current: {
        key: 'current',
        fileId: '00000000-0000-0000-0000-0000000f11e2',
        fileName: 'current.csv',
        xLabel: 'Time (s)',
        yLabel: 'Current (A)',
        samples: 5,
        points: [[0, 0, 0], [0.001, 8, 12.5], [0.002, 4, 6], [0.004, 1, 2], [0.01, 0.5, 0.6]],
        error: null,
      },
    },
    reportTemplate: {
      id: '00000000-0000-0000-0000-0000000007e1',
      title: 'Report for Inrush current',
      reportCreator: 'author@example.com',
      requirement: 'REQ-0001',
      testMethod: 'TM-0001',
      testPlanNumber: 'TP-0001',
      testPlanRevision: 'A',
    },
    ...overrides,
  };
}
